/* eslint-disable max-classes-per-file */

import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import {
  IPlannedActivityRequest,
  IPlannedActivityBulkUpdateRequest,
  IPlannedActivityUpdateRequest,
} from '../../models/planned-activities/planned-activity.model';

export class LoadPlannedActivities {
  static readonly type = '[PlannedActivities] Load Planned Activities';
  constructor(public filter?: MainTableFilterModel) {}
}

export class LoadPlannedActivitiesForTenant {
  static readonly type = '[PlannedActivities] Load Planned Activities For Tenant';
  constructor(public filter?: MainTableFilterModel) {}
}

export class LoadPlannedActivitiesUsers {
  static readonly type = '[PlannedActivities] Load Planned Activities Users';
  constructor(public filter?: MainTableFilterModel) {}
}

export class LoadConflictingActivitiesForUser {
  static readonly type = '[PlannedActivities] Load Conflicting Activities For Users';
  constructor(
    public from: Date,
    public to: Date,
    public userId: string,
    public plannedActivityId: string,
    public departmentId?: string
  ) {}
}

export class LoadPlannedActivityById {
  static readonly type = '[PlannedActivities] Load Planned Activity By Id';
  constructor(public plannedActivityId: string, public departmentId?: string) {}
}

export class CreatePlannedActivity {
  static readonly type = '[PlannedActivities] Create Planned Activity';
  constructor(public plannedActivity: IPlannedActivityRequest) {}
}

export class UpdatePlannedActivity {
  static readonly type = '[PlannedActivities] Update Planned Activity';
  constructor(
    public plannedActivity: IPlannedActivityUpdateRequest,
    public departmentId?: string
  ) {}
}

export class UpdatePlannedActivities {
  static readonly type = '[PlannedActivities] Update Planned Activities';
  constructor(
    public plannedActivities: IPlannedActivityBulkUpdateRequest[],
    public departmentId?: string
  ) {}
}

export class DeletePlannedActivity {
  static readonly type = '[PlannedActivities] Delete Planned Activity';
  constructor(public plannedActivityId: string, public departmentId?: string) {}
}

export class DeletePlannedActivities {
  static readonly type = '[PlannedActivities] Delete Planned Activities';
  constructor(public plannedActivities: IPlannedActivityBulkUpdateRequest[]) {}
}

export class ResetPlannedActivitiesUsersFilter {
  static readonly type = '[PlannedActivities] Reset Planned Activities Users Filter';
  constructor() {}
}

export class ClearPlannedActivities {
  static readonly type = '[PlannedActivities] Clear Planned Activities';
  constructor() {}
}
